"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FaceOkSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var FaceOkSVG = function FaceOkSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M16,2A14,14,0,1,1,2,16,14,14,0,0,1,16,2Zm4.52,17.5H10.88a1,1,0,0,0,.12,2h9.63a1,1,0,0,0-.11-2ZM12,11a2,2,0,1,0,2,2A2,2,0,0,0,12,11Zm8,0a2,2,0,1,0,2,2A2,2,0,0,0,20,11Z"
  }));
};
exports.FaceOkSVG = FaceOkSVG;
FaceOkSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(FaceOkSVG);
exports.default = _default;